// source: https://www.joshwcomeau.com/snippets/react-hooks/use-mouse-position/

import React from 'react';
import { relPosition } from '../AppState';


const useMousePosition: ()=>relPosition = ()=> {
  const [
    mousePosition,
    setMousePosition
  ]: [relPosition, any] = React.useState({ pctX: null, pctY: null });

  React.useEffect(() => {
    const updateMousePosition = ev => {
      if (window.visualViewport !== null){
        setMousePosition({ pctX: ev.clientX / window.visualViewport?.width , pctY: ev.clientY / window.visualViewport?.height });
      } else {
        setMousePosition({x: null, y: null})
      }
    };

    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

  return mousePosition;
};

export default useMousePosition;